import React from "react";

const Footer = () => {
  return (
    <footer className="bg-white text-center w-full fixed z-30 h-[calc(env(safe-area-inset-bottom) + 5px)] md:h-auto md:right-0 bottom-0">
      <span className="text-sm text-gray-500">
        © 2025{" "}{process.env.REACT_APP_TITLE}™
        . All Rights Reserved.
      </span>
    </footer>
  );
};

export default Footer;
